import { makeStyles } from "@mui/styles";
import React, { useState } from "react";
import {
  Box,
  Button,
  Card,
  Checkbox,
  Chip,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import moment from "moment";
import { PictureAsPdf } from "@mui/icons-material";
import { downloadData } from "../../../../service/Service";
import { getVegetable } from "../../../../redux/reducer/vegetable/vegetableReducer";
import { LoadingButton } from "@mui/lab";
import { getFarmer } from "../../../../redux/reducer/farmer/farmerReducer";
import { getReportHarvestEstimateFarmer } from "../../../../redux/reducer/harvest-estimate/reportHarvestEstimateReducer";
import SpvReportHarvestEstimateFarmerTable from "./SpvReportHarvestEstimateFarmerTable";

const useStyles = makeStyles(() => ({
  headerClassSearch: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: "column",
    padding: "0px 5px",
    margin: "10px 0px",
    background: "#F2F2F2",
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

export default function SpvReportHarvestEstimateFarmer() {
  // Styling
  const styles = useStyles();

  //Redux
  const token = useSelector((state) => state.auth.token);
  const vegetableData = useSelector((state) => state.vegetable.data);
  const farmerData = useSelector((state) => state.farmer.data);
  const loading = useSelector((state) => state.reportHarvestEstimate.isLoading);
  const data = useSelector((state) => state.reportHarvestEstimate.data.dashboardFarmer);
  const dispatch = useDispatch();

  // Local State
  const [formInput, setFormInput] = useState({
    to: "",
    from: "",
  });

  const [vegetable, setVegetable] = useState([]);
  const [allVegetable, setAllVegetable] = useState(false);
  const [allFarmer, setAllFarmer] = useState(false);
  const [farmer, setFarmer] = useState([]);
  const [loadingDownload, setLoadingDownload] = useState(false);
  const [show, setShow] = useState(false);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setVegetable(typeof value === "string" ? value.split(",") : value);
  };

  const handleChangeFarmer = (event) => {
    const {
      target: { value },
    } = event;
    setFarmer(typeof value === "string" ? value.split(",") : value);
  };

  const handleChangeCheckbox = (e) => {
    setAllVegetable(e.target.checked);
  };

  const handleChangeCheckboxFarmer = (e) => {
    setAllFarmer(e.target.checked);
  };

  const handleChangeInput = (e) => {
    setFormInput({
      ...formInput,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let vegetableIds = [];
    for (let x in vegetable) {
      vegetableIds.push(vegetable[x]);
    }

    let farmerIds = [];
    for (let x in farmer) {
      farmerIds.push(farmer[x]);
    }

    const formData = {
      data: {
        selectedFarmer: !allFarmer,
        farmerId: { $in: farmerIds },
        selectedVegetable: !allVegetable,
        vegetableId: { $in: vegetableIds },
        createdAt: {
          $gte: moment(formInput.from).format(),
          $lte: moment(formInput.to).format(),
        },
      },
      token: token,
    };
    dispatch(getReportHarvestEstimateFarmer(formData)).then((res) => {
      toast.success(res.payload.message);
      setShow(true);
    });
  };

  const handleReset = () => {
    setShow(false);
    setFormInput({
      to: "",
      from: "",
    });
    setVegetable([]);
    setAllVegetable(true);
  };

  const loadMore = (value) => (event) => {
    if (
      event.target.scrollHeight - event.target.scrollTop < 300 &&
      event.target.scrollTop < 200
    ) {
      if (vegetable.totalDocs !== vegetable.docs.length && value === 1) {
        const getData = {
          params: {
            limit: vegetable.limit + 10,
            page: 1,
          },
          token: token,
        };
        dispatch(getVegetable(getData));
      } else if (farmer.totalDocs !== farmer.docs.length && value === 2) {
        const getData = {
          params: {
            limit: farmer.limit + 10,
            page: 1,
          },
          token: token,
        };
        dispatch(getFarmer(getData));
      }
    }
  };

  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
      onScroll: loadMore(1),
    },
  };

  const MenuFarmerProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
      onScroll: loadMore(2),
    },
  };

  const handleDownloadReport = () => {
    setLoadingDownload(true);
    let vegetableIds = [];
    for (let x in vegetable) {
      vegetableIds.push(vegetable[x]);
    }

    let farmerIds = [];
    for (let x in farmer) {
      farmerIds.push(farmer[x]);
    }

    const formData = {
      data: {
        selectedFarmer: !allFarmer,
        farmerId: { $in: farmerIds },
        selectedVegetable: !allVegetable,
        vegetableId: { $in: vegetableIds },
        createdAt: {
          $gte: moment(formInput.from).format(),
          $lte: moment(formInput.to).format(),
        },
      },
      token: token,
    };
    downloadData(
      "/farmer/harvest-estimate/report/farmer/export",
      formData.token,
      formData.data
    )
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `LAPORAN_ESTIMASI_PANEN_PETANI_${formInput.from}_sampai_${formInput.to}.pdf`
        ); //or any other extension
        document.body.appendChild(link);
        link.click();
        setLoadingDownload(false);
      })
      .catch((err) => {
        if (err) {
          setLoadingDownload(false);
        }
      });
  };
  return (
    <>
      <ToastContainer />
      <Card className={styles.headerClassSearch}>
        <form onSubmit={handleSubmit} style={{ width: "100%" }}>
          <Grid padding={0.5} container spacing={0.5} flexDirection={"column"}>
            <Grid
              item
              container
              xs={12}
              sm={12}
              direction="row"
              alignItems="center"
              justifyContent={"space-between"}
            >
              <div
                style={{ display: "flex", alignItems: "center", width: "30%" }}
              >
                <Typography variant="h6" color="primary">
                  LAPORAN ESTIMASI PANEN PETANI
                </Typography>
              </div>
              <div style={{ display: "flex", width: "50%" }}>
                <FormControl
                  variant="standard"
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "row",
                    width: "100%",
                    margin: "10px",
                  }}
                >
                  <TextField
                    InputLabelProps={{ shrink: true }}
                    label="Dari"
                    name="from"
                    size="small"
                    type="date"
                    required
                    onChange={handleChangeInput}
                    value={formInput.from}
                    variant="outlined"
                    style={{ width: "49%" }}
                  />
                  <TextField
                    InputLabelProps={{ shrink: true }}
                    label="Ke"
                    name="to"
                    size="small"
                    type="date"
                    required
                    onChange={handleChangeInput}
                    value={formInput.to}
                    variant="outlined"
                    style={{ width: "49%" }}
                  />
                </FormControl>
              </div>
            </Grid>
            <Divider style={{ width: "100%", border: "1px solid black" }} />
            <Grid
              item
              container
              xs={12}
              sm={12}
              direction="column"
              justifyContent="space-evenly"
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "80%",
                }}
              >
                <div style={{ width: "15%" }}>
                  <Typography>Petani</Typography>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "85%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <FormControl sx={{ margin: "5px", width: 300 }}>
                      <Select
                        labelId="demo-multiple-chip-label"
                        id="demo-multiple-chip"
                        multiple
                        disabled={allFarmer}
                        value={farmer}
                        required
                        size="small"
                        onChange={handleChangeFarmer}
                        renderValue={(selected) => (
                          <Box
                            sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}
                          >
                            {selected.map((value) => (
                              <Chip key={value._id} label={value.fullName} />
                            ))}
                          </Box>
                        )}
                        MenuProps={MenuFarmerProps}
                      >
                        {farmerData.docs.map((data, index) => (
                          <MenuItem key={index} value={data}>
                            {data.fullName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div>
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox />}
                        label="Semua Petani"
                        value={allFarmer}
                        onChange={handleChangeCheckboxFarmer}
                      />
                    </FormGroup>
                  </div>
                </div>
              </div>
            </Grid>

            <Grid
              item
              container
              xs={12}
              sm={12}
              direction="column"
              justifyContent="space-evenly"
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "80%",
                }}
              >
                <div style={{ width: "15%" }}>
                  <Typography>Sayuran</Typography>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "85%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <FormControl sx={{ margin: "5px", width: 300 }}>
                      <Select
                        labelId="demo-multiple-chip-label"
                        id="demo-multiple-chip"
                        multiple
                        disabled={allVegetable}
                        value={vegetable}
                        required
                        size="small"
                        onChange={handleChange}
                        renderValue={(selected) => (
                          <Box
                            sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}
                          >
                            {selected.map((value) => (
                              <Chip
                                key={value._id}
                                label={value.vegetableName}
                              />
                            ))}
                          </Box>
                        )}
                        MenuProps={MenuProps}
                      >
                        {vegetableData.docs.map((data, index) => (
                          <MenuItem key={index} value={data}>
                            {data.vegetableName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div>
                    <FormGroup>
                      <FormControlLabel
                        control={<Checkbox />}
                        label="Semua Sayuran"
                        value={allVegetable}
                        onChange={handleChangeCheckbox}
                      />
                    </FormGroup>
                  </div>
                </div>
              </div>
            </Grid>

            <Grid
              container
              item
              justifyContent="flex-end"
              xs={12}
              sm={12}
              marginBottom={1}
            >
              <LoadingButton
                variant="contained"
                size="small"
                style={{ margin: "0px 5px" }}
                type="submit"
                loading={loading}
              >
                Submit
              </LoadingButton>
              <Button
                variant="contained"
                size="small"
                color="error"
                style={{ margin: "0px 10px" }}
                onClick={() => handleReset()}
              >
                Reset
              </Button>
            </Grid>
          </Grid>
        </form>
      </Card>

      <Card
        style={{
          padding: "10px",
          background: "#F2F2F2",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {show ? (
          <>
            <LoadingButton
              style={{
                margin: "20px 0px",
                backgroundColor: "#AE3336",
                width: "20%",
              }}
              variant="contained"
              loading={loadingDownload}
              onClick={() => handleDownloadReport()}
            >
              Download PDF
              <i style={{ alignItems: "center" }}>
                <PictureAsPdf />
              </i>
            </LoadingButton>
            <SpvReportHarvestEstimateFarmerTable data={data}/>
          </>
        ) : (
          <Typography fontStyle={"italic"}>
            Silahkan Mengisi Form Terlebih Dahulu*{" "}
          </Typography>
        )}
      </Card>
    </>
  );
}
